import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[lettersOnly]'
})
export class LettersOnlyDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.filterInput();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    // Delay handling to ensure paste operation is complete
    setTimeout(() => this.filterInput(), 0);
  }

  private filterInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;
    // Remove any non-letter characters
    input.value = value.replace(/[^a-zA-Z]/g, '');
    // Trigger the input event
    input.dispatchEvent(new Event('input'));
  }
}
